export const MEMBERSHIP_STATUS = {
  activated: 1,
  cancelled:2,
  paused: 3,
  notActivated: 4,
  ended: 5,
  pastDue: 6,
}